import React from "react";

function BackgroundImage() {
  return (
    <div>
      <img
        className="w-screen h-screen brightness-50"
        src="https://assets.nflxext.com/ffe/siteui/vlv3/701eec50-4b87-4dc0-9d00-b0f54025dc36/028e62d2-2a59-4fc3-adaa-a0756a0512b9/IN-en-20220905-popsignuptwoweeks-perspective_alpha_website_small.jpg"
        alt="Neflix logo"
      />
    </div>
  );
}

export default BackgroundImage;
